import { createAction } from 'redux-actions';
export const SET_LEGS = 'SET_LEGS';
export const setLegs = createAction(SET_LEGS, (legs) => legs);
